import * as types from "./actionTypes";
import axios from "axios";

export const getData = (params) => (dispatch) => {
  dispatch({ type: types.GET_DATA_REQUEST });
  return axios
    .get("https://learn-heroku-api.herokuapp.com/cards", params)
    .then((r) => {
      return dispatch({ type: types.GET_DATA_SUCCESS, payload: r.data });
    })
    .catch((e) => {
      return dispatch({ type: types.GET_DATA_FAILURE });
    });
};
